var locales = require('./locales.json')
var t = require('../translate')

var Vue = require('vue')

module.exports = {
  methods: {
    t: function(name) {
      return t(locales, name);
    }
  },
  template: require('./bought_modal.html')
};



// WEBPACK FOOTER //
// ./lib/runes-set-order/bought_modal.js